export default "__VITE_ASSET__Y9g$eUFM__"